import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import { min } from 'mathjs';
import chooseList from '../../product_price/form/product_list.vue';

formCreate.component('chooseList', chooseList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {

    };
  },
  async created() {
    await this.getFormRule('main-form');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const v = item;
      if (v.field === 'userName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'choose-people-list',
            parentCode: 'CRM20260605000000003',
            paramData: {
              enableStatus: '009',
            },
          },
          title: '选择人员',
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e && e.length) {
              const objProduct = e[0];
              this.setValue({
                userCode: objProduct.userName,
                userName: objProduct.fullName,
                userRole: objProduct.positionLevelName,
              });
            }
          },
        };
      }
      if (v.field === 'productSeriesName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'choose-series-list',
            parentCode: 'CRM20260526000000010',
            paramData: {
              enableStatus: '009',
            },
          },
          title: '选择系列',
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e && e.length) {
              this.setValue({
                productSeriesName: e.map((t) => t.productLevelName).join(','),
                productSeriesCode: e.map((t) => t.productLevelCode).join(','),
              });
            }
          },
        };
      }
      if (v.field === 'promotionOrgCode') {
        v.on = {
          ...v.on,
          getItem: (e) => {
            this.setValue({
              promotionOrgName: e.dictValue,
            });
          },
        };
      }
      if (v.field === 'supervisorWeight') {
        v.props = {
          ...v.props,
          min: 0,
          max: 100,
          precision: 2,
        };
      }
      return v;
    },
    // 渲染完成后执行
    formComplete() {
      const {
        code,
      } = this.formConfig;
      this.disabled(true, ['bindName']);
      if (code === 'view' || code === 'edit') {
        request.post('/mdm/performanceuserbind/query', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const {
              result,
            } = res;
            this.setValue({
              ...result,
              statMonth: `${result.statMonth}`,
              productSeriesName: result.productSeriesVos.map((t) => t.productSeriesName).join(',') || '',
              productSeriesCode: result.productSeriesVos.map((t) => t.productSeriesCode).join(',') || '',
            });
          }
        });
      }
      const bindType = this.getRule('bindType');
      const bindName = this.getRule('bindName');
      bindType.on = {
        ...bindType.on,
        change: (value) => {
          if (value) {
            this.disabled(false, ['bindName']);
            if (value === 'dealer') {
              bindName.props = {
                ...bindName.props,
                params: {
                  functionCode: 'choose-dealer-list',
                  parentCode: 'CRM20260526000000010',
                  paramData: {
                    enableStatus: '009',
                    actApproveStatus: '3',
                    customerType: 'dealer',
                  },
                },
                title: '选择经销商',
              };
              bindName.on = {
                ...bindName.on,
                change: (e) => {
                  if (e && e.length) {
                    this.setValue({
                      bindName: e[0].customerName,
                      bindCode: e[0].customerCode,
                    });
                  }
                },
              };
            } else if (value === 'terminal') {
              bindName.props = {
                ...bindName.props,
                params: {
                  functionCode: 'choose-terminal-list',
                  parentCode: 'CRM20260526000000010',
                  paramData: {
                    enableStatus: '009',
                  },
                },
                title: '选择终端',
              };
              bindName.on = {
                ...bindName.on,
                change: (e) => {
                  if (e && e.length) {
                    this.setValue({
                      bindName: e[0].bindName,
                      bindCode: e[0].bindCode,
                    });
                  }
                },
              };
            }
          } else {
            this.disabled(true, ['bindName']);
            this.setValue({
              bindName: '',
              bindCode: '',
            });
          }
        },
      };
    },
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/mdm/performanceuserbind/save';
        let productSeriesVos = [];
        if (formData.productSeriesCode) {
          const productSeriesCode = formData.productSeriesCode.split(',');
          const productSeriesName = formData.productSeriesName.split(',');
          productSeriesVos = productSeriesCode.map((item, index) => ({
            productSeriesCode: item,
            productSeriesName: productSeriesName[index],
          }));
        }
        const params = {
          ...formData,
          statMonth: Number(formData.statMonth),
          productSeriesVos,
        };
        if (this.formConfig.code === 'edit') {
          url = '/mdm/performanceuserbind/update';
          params.id = this.formConfig.row.id;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
